import { BulkMigration } from '@domains/subscription/priv/Templates/BulkMigration'
import useMaterialNotification from 'hooks/useMaterialNotification'
import { useState } from 'react'
import { useGetMigrationStatus, useStartMigration, useUploadMigrationFile } from '../api/queries'

export const BulkMigrationFactory = () => {
  const [fileId, setFileId] = useState<string>()
  const [migrationState, setMigrationState] = useState<'idle' | 'migrating'>('idle')
  const uploadMutation = useUploadMigrationFile()
  const startMutation = useStartMigration()
  const { data: migrationStatus } = useGetMigrationStatus(fileId, migrationState === 'migrating')
  const notify = useMaterialNotification()

  const handleUpload = async (file: File) => {
    const result = await uploadMutation.mutateAsync(file)
    setFileId(result.fileId)
    return result
  }

  const handleStartMigration = async (fileId: string) => {
    await startMutation.mutateAsync(fileId, {
      onSuccess: () => {
        setMigrationState('migrating')
      },
    })

    notify('Migration started')
  }

  return (
    <BulkMigration
      onUpload={handleUpload}
      onStartMigration={handleStartMigration}
      migrationStatus={migrationStatus}
      isUploading={uploadMutation.isLoading}
      isStarting={startMutation.isLoading}
      onClose={() => setMigrationState('idle')}
    />
  )
}
